import { render, staticRenderFns } from "./termsUse.vue?vue&type=template&id=7d82a9c6&scoped=true"
import script from "./termsUse.vue?vue&type=script&lang=js"
export * from "./termsUse.vue?vue&type=script&lang=js"
import style0 from "./termsUse.vue?vue&type=style&index=0&id=7d82a9c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d82a9c6",
  null
  
)

export default component.exports